<template>
  <div class="x-loading">
    <img v-if="displayVisable" :src="loadingGif" alt="" srcset="" />
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: 'XLoading',
  props: {
    visible: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    timer: {
      type: Number,
      default: function() {
        return 300
      }
    }
  },
  data() {
    return {
      displayVisable: false,
      timestamp: 0,
      loadingGif: require('../../assets/icon/loading.gif')
    }
  },
  watch: {
    visible: {
      handler: function(newVal, oldVal) {
        if (newVal) {
          this.timestamp = new Date().getTime()
          this.displayVisable = true
        } else {
          const endTimestamp = new Date().getTime()
          const temp = endTimestamp - this.timestamp
          if (temp >= this.timer) {
            this.displayVisable = false
            this.$emit('loading-done')
          } else {
            const timeout = setTimeout(() => {
              this.displayVisable = false
              this.$forceUpdate()
              clearTimeout(timeout)
              this.$emit('loading-done')
            }, this.timer - temp)
          }
        }
      },
      immediate: true
    }
  }
}
</script>
